import {State} from '../state';
import {IUserDashboardState} from './state';
import {getStoreAccessors} from "typesafe-vuex";

export const getters = {
    ordersMetrics: (state: IUserDashboardState) => state.ordersMetrics,
    //selectedBranchId: (state: IUserDashboardState) => state.selectedBranchId
};

export const {read} = getStoreAccessors<IUserDashboardState, State>('');
export const readOrdersMetrics = read(getters.ordersMetrics);
//export const readSelectedBranchId = read(getters.selectedBranchId);
